type MessageTimestampProps = {
  value?: number | string;
  align?: 'left' | 'right';
};

function parseTimestamp(value?: number | string) {
  if (value === undefined) return null;
  const normalized = typeof value === 'number' && value < 1_000_000_000_000
    ? value * 1000
    : value;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function MessageTimestamp({ value, align = 'left' }: MessageTimestampProps) {
  const date = parseTimestamp(value);
  if (!date) return null;

  return (
    <time
      dateTime={date.toISOString()}
      title={date.toLocaleString('pt-BR')}
      style={{
        alignSelf: align === 'right' ? 'flex-end' : 'flex-start',
        color: 'rgba(255,255,255,0.38)',
        fontSize: '10px',
        lineHeight: 1.2,
      }}
    >
      {date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })}
    </time>
  );
}
